export enum ContractPathsEnum {
  contracts = '/contracts',
}
